<template>
    <div>
        <!-- SELECT FISCAL YEARS -->
        <FiscalYearsSelect
            :fiscalYears="form.fiscalyears"
            @updateFiscalYears="updateFiscalYears"
            @loaded="$emit('updateLoading', { loading: false })"
        />

        <!-- SELECT STATES -->
        <el-form-item
            :label="$t.__('dashboard.forms.EstimateSettingForm.select_status_to_display')"
            prop="states"
        >
            <el-select v-model="form.states" multiple :multipleLimit="2" class="wp-5">
                <el-option
                    v-for="state in statesList"
                    :key="state.value"
                    :label="state.label"
                    :value="state.value"
                >
                </el-option>
            </el-select>
        </el-form-item>
        <!-- RADIO TAX -->
        <el-form-item :label="$t.__('common.actions.select_tax_display')" prop="taxMode">
            <CompassRadioGroup v-model="form.taxMode" direction="vertical">
                <CompassRadio modelValue="exc" :label="$l10n.__('HT')" />
                <CompassRadio modelValue="inc" :label="$l10n.__('TTC')" />
            </CompassRadioGroup>
        </el-form-item>
    </div>
</template>

<script>
import SettingsFormMixin from './SettingsFormMixin.js';
import FiscalYearsSelect from './FiscalYearsSelect.vue';

export default {
    components: {
        FiscalYearsSelect,
    },
    mixins: [SettingsFormMixin],
    data() {
        var checkStates = (rule, value, callback) => {
            if (value.length != 2) {
                callback(new Error(this.$l10n.__('Veuillez sélectionner deux status')));
            } else {
                callback();
            }
        };
        return {
            estimateRules: {
                states: [{ validator: checkStates, trigger: 'change' }],
                taxMode: [
                    {
                        required: true,
                        message: this.$l10n.__("Veuillez sélectionner un mode d'affichage"),
                        trigger: 'change',
                    },
                ],
            },
            statesList: [
                {
                    value: 'accepted',
                    label: this.$l10n.__('En attente de facturation'),
                },
                {
                    value: 'sent',
                    label: this.$l10n.__('En attente de validation'),
                },
                {
                    value: 'expired',
                    label: this.$l10n.__('Expiré'),
                },
            ],
        };
    },
    created() {
        this.$emit('updateLoading', { loading: true });
    },
    mounted() {
        this.$emit('set-rules', this.estimateRules);
    },
    methods: {
        close() {
            this.$emit('close-form');
        },
        updateFiscalYears(data) {
            this.form.fiscalyears = data;
        },
    },
};
</script>
